import evVideo from './EvVideo'

/**
 * Imgwall video - single Rutube video, poster/play button swapped inline for the iframe on click.
 */
function getEmbedUrl(raw) {
    const value = (raw || '').trim()

    if (!value) {
        return ''
    }

    if (/^[a-zA-Z0-9]+$/.test(value)) {
        return `https://rutube.ru/play/embed/${value}/?skinColor=181818`
    }

    return evVideo.getRutubeEmbedUrl(value) || ''
}

function attachRutubeAutoplay(iframe) {
    const handler = (event) => {
        if (event.origin !== 'https://rutube.ru') {
            return
        }

        if (!iframe.contentWindow || event.source !== iframe.contentWindow) {
            return
        }

        let message
        try {
            message = JSON.parse(event.data)
        } catch (e) {
            return
        }

        if (!message || message.type !== 'player:ready') {
            return
        }

        try {
            iframe.contentWindow.postMessage(JSON.stringify({ type: 'player:play', data: {} }), '*')
        } catch (e) {
            // noop
        }

        window.removeEventListener('message', handler)
    }

    window.addEventListener('message', handler)
}

function handleOpen(trigger, container) {
    const embedUrl = getEmbedUrl(trigger.dataset.videoId)

    if (!embedUrl) {
        return
    }

    const iframe = document.createElement('iframe')
    iframe.width = '100%'
    iframe.height = '100%'
    iframe.frameBorder = '0'
    iframe.allowFullscreen = true
    iframe.setAttribute('allowfullscreen', '')
    iframe.setAttribute('allow', 'autoplay; fullscreen; accelerometer; gyroscope; picture-in-picture; encrypted-media')
    iframe.title = 'Rutube video player'
    iframe.src = embedUrl

    container.innerHTML = ''
    container.appendChild(iframe)
    container.hidden = false
    trigger.hidden = true

    attachRutubeAutoplay(iframe)
}

export default function initImgwallVideo() {
    document.querySelectorAll('.imgwall__video').forEach((root) => {
        const trigger = root.querySelector('[data-imgwall-video-open]')
        const container = root.querySelector('[data-imgwall-video-container]')

        if (!trigger || !container) {
            return
        }

        trigger.addEventListener('click', () => handleOpen(trigger, container))
    })
}
